import { ActivityCategoryTypesEnum } from './activity-category-types';

export class ActivityCategoryType {
  name: string;
  id: ActivityCategoryTypesEnum;

  constructor(name: string, id: ActivityCategoryTypesEnum) {
    this.name = name;
    this.id = id;
  }
}
